import type { CreativeV5Type } from '../apis/graphql';
import { DXC_CREATIVE_TYPES } from '../common/constants/creative';

export const isDxcCreativeType = (creativeType: CreativeV5Type): boolean => {
  return DXC_CREATIVE_TYPES.includes(creativeType);
};
